module.exports = __webpack_public_path__ + "images/03_0d6cdd48.png";